import React from 'react'
import LoginForm from 'molecules/LoginForm'
import { ModalContainer, ModalHead } from './styles'
import ModalPage from 'components/templates/ModalPage/index';
import { Label } from 'atoms/Texts'
import IconPng from 'components/atoms/IconPng/index';
import ButtonReg from 'components/atoms/Buttons/Button'

const ic_cancel = require('App/assets/images/ic_cancel.png')

const LoginClassicModal = props => (
  <ModalPage
    isOpen={props.isShowClassicLoginModal}
    width={'450px'}
    height={'fit-content'}
    fnSwitch={props.switchClassicLoginModal}
    contentChild={
      <ModalContainer>
        <ModalHead>
          <div style={{ position: 'absolute', top: '6px', right: '16px' }}>
            <ButtonReg
              btnTxt={
                <IconPng srcIcon={ic_cancel} size={'auto'} h={'14'} showPointer={true} onClick={props.switchClassicLoginModal} />
              }
              onClick={props.fnSwitch}
              width={'fit-content'}
              height={'34px'}
              transparent
            />
          </div>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'} textAlign={'center'} textOverflow>
            Classic Login
          </Label>
        </ModalHead>
        <hr />
        <LoginForm {...props} />
      </ModalContainer>
    }
  />
)

export default LoginClassicModal

